import React from "react";
import { useCurrentUser } from "@/hooks/useCurrentUser";
import { formatDate } from "@/utils/dateUtils";
import { Badge } from "@/components/ui/badge";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";

/** Organizations the user can work in (active memberships only, from /accounts/me/). */
const ProfileOrganizationsCard: React.FC = () => {
  const { user } = useCurrentUser();
  const organizations = user?.organizations ?? [];

  return (
    <Card className="min-w-0">
      <CardHeader>
        <CardTitle>Organizations</CardTitle>
      </CardHeader>
      <CardContent>
        <ul className="divide-y">
          {organizations.map((org) => (
            <li
              key={org.id}
              className="flex flex-wrap items-center justify-between gap-x-4 gap-y-1 py-2"
            >
              <div className="flex min-w-0 flex-wrap items-center gap-2">
                <span className="break-words font-medium">{org.name}</span>
                {org.is_primary && <Badge variant="secondary">Primary</Badge>}
              </div>
              {org.joined_at && (
                <span className="whitespace-nowrap text-sm text-muted-foreground">
                  Joined {formatDate(org.joined_at)}
                </span>
              )}
            </li>
          ))}
        </ul>
      </CardContent>
    </Card>
  );
};

export default ProfileOrganizationsCard;
